var _path, _path2, _path3, _ellipse, _ellipse2, _ellipse3, _ellipse4, _ellipse5, _ellipse6, _ellipse7, _ellipse8;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLocationAccess(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 66,
    viewBox: "0 0 64 66",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M33.3819 36.6832C36.0409 36.6832 38.1964 34.4956 38.1964 31.7971C38.1964 29.0985 36.0409 26.9109 33.3819 26.9109C30.7229 26.9109 28.5674 29.0985 28.5674 31.7971C28.5674 34.4956 30.7229 36.6832 33.3819 36.6832ZM33.3819 38.3119C36.9272 38.3119 39.8012 35.3951 39.8012 31.7971C39.8012 28.199 36.9272 25.2822 33.3819 25.2822C29.8366 25.2822 26.9626 28.199 26.9626 31.7971C26.9626 35.3951 29.8366 38.3119 33.3819 38.3119Z",
    fill: "#C2C2C2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.7311 63.3533C19.4939 63.5298 20.5447 63.6954 21.8379 63.8395C24.7775 64.1669 28.8592 64.3713 33.3819 64.3713C37.9046 64.3713 41.9864 64.1669 44.9259 63.8395C46.2191 63.6954 47.2699 63.5298 48.0327 63.3533C47.2699 63.1769 46.2191 63.0113 44.9259 62.8672C41.9864 62.5398 37.9046 62.3354 33.3819 62.3354C28.8592 62.3354 24.7775 62.5398 21.8379 62.8672C20.5447 63.0113 19.4939 63.1769 18.7311 63.3533ZM21.6628 61.2482C24.6768 60.9125 28.8198 60.7067 33.3819 60.7067C37.944 60.7067 42.087 60.9125 45.101 61.2482C46.6028 61.4155 47.8521 61.618 48.7403 61.8519C49.178 61.9671 49.5735 62.1015 49.8765 62.2664C50.0271 62.3484 50.1956 62.4595 50.3355 62.6129C50.479 62.7704 50.6338 63.0211 50.6338 63.3533C50.6338 63.6856 50.479 63.9363 50.3355 64.0938C50.1956 64.2472 50.0271 64.3583 49.8765 64.4403C49.5735 64.6052 49.178 64.7395 48.7403 64.8548C47.8521 65.0887 46.6028 65.2912 45.101 65.4585C42.087 65.7942 37.944 66 33.3819 66C28.8198 66 24.6768 65.7942 21.6628 65.4585C20.161 65.2912 18.9117 65.0887 18.0236 64.8548C17.5859 64.7395 17.1903 64.6052 16.8873 64.4403C16.7367 64.3583 16.5682 64.2472 16.4284 64.0938C16.2848 63.9363 16.13 63.6856 16.13 63.3533C16.13 63.0211 16.2848 62.7704 16.4284 62.6129C16.5682 62.4595 16.7367 62.3484 16.8873 62.2664C17.1903 62.1015 17.5859 61.9671 18.0236 61.8519C18.9117 61.618 20.161 61.4155 21.6628 61.2482Z",
    fill: "#C2C2C2"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M41.5699 14.7379C36.4749 11.9782 30.1596 11.8243 25.3346 14.8843C18.0487 19.5049 15.3859 27.2902 16.6233 33.4674C17.4433 37.5616 19.3919 40.8985 22.3432 44.3168C24.8516 47.2219 28.0467 50.1461 31.8572 53.6333C32.381 54.1126 32.9164 54.6026 33.4632 55.1046C34.5412 54.0151 35.5642 52.9943 36.5365 52.0239C41.4204 47.1498 45.027 43.5505 47.9267 38.9291C49.7489 36.025 50.8495 32.6904 50.7723 29.3118C50.6984 26.0814 49.922 23.2771 48.422 20.8726C46.9208 18.4663 44.6665 16.4152 41.5699 14.7379ZM24.4842 13.5031C29.8666 10.0896 36.8017 10.309 42.3255 13.301C45.6193 15.0851 48.1016 17.3144 49.7779 20.0014C51.4553 22.6901 52.2971 25.7918 52.3767 29.274C52.4627 33.0359 51.2382 36.6836 49.2804 39.804C46.2738 44.5956 42.509 48.3512 37.6102 53.238C36.487 54.3585 35.3043 55.5383 34.0574 56.8038L33.517 57.3522L32.951 56.8312C32.2164 56.1552 31.4986 55.4984 30.7987 54.858C26.9917 51.3745 23.7124 48.3739 21.1362 45.3901C18.0666 41.8348 15.9433 38.2484 15.0506 33.7918C13.6764 26.9313 16.6457 18.4741 24.4842 13.5031Z",
    fill: "#C2C2C2"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    opacity: 0.5,
    cx: 12.0161,
    cy: 51.9062,
    rx: 1.01613,
    ry: 1.03125,
    fill: "#C2C2C2"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    opacity: 0.5,
    cx: 40.4684,
    cy: 0.6875,
    rx: 0.677419,
    ry: 0.6875,
    fill: "#C2C2C2"
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    opacity: 0.5,
    cx: 13.7095,
    cy: 3.78125,
    rx: 1.01613,
    ry: 1.03125,
    fill: "#C2C2C2"
  })), _ellipse4 || (_ellipse4 = /*#__PURE__*/React.createElement("ellipse", {
    opacity: 0.5,
    cx: 2.19355,
    cy: 21.6562,
    rx: 1.69355,
    ry: 1.71875,
    fill: "#C2C2C2"
  })), _ellipse5 || (_ellipse5 = /*#__PURE__*/React.createElement("ellipse", {
    opacity: 0.5,
    cx: 56.0485,
    cy: 52.25,
    rx: 0.677419,
    ry: 0.6875,
    fill: "#C2C2C2"
  })), _ellipse6 || (_ellipse6 = /*#__PURE__*/React.createElement("ellipse", {
    opacity: 0.5,
    cx: 57.404,
    cy: 14.4375,
    rx: 0.677419,
    ry: 0.6875,
    fill: "#C2C2C2"
  })), _ellipse7 || (_ellipse7 = /*#__PURE__*/React.createElement("ellipse", {
    opacity: 0.5,
    cx: 1.17742,
    cy: 39.1875,
    rx: 0.677419,
    ry: 0.6875,
    fill: "#C2C2C2"
  })), _ellipse8 || (_ellipse8 = /*#__PURE__*/React.createElement("ellipse", {
    opacity: 0.5,
    cx: 62.1459,
    cy: 35.0625,
    rx: 1.35484,
    ry: 1.375,
    fill: "#C2C2C2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocationAccess);
export default __webpack_public_path__ + "static/media/locationAccess.608e171f7555fc6fb38beae50d14ec78.svg";
export { ForwardRef as ReactComponent };